import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)

const state = {
    smsList: [],
    smsContentList: [],
    ottList: [],
    enachList: [],
    aadhaarkycList: [],
    ipPhoneList: [],
    ipPhoneContentList: [],
    iptvList: [],
    iptvContentList: [],
    quickBookList: [],
    webHooksList: [],
    oneSignalList: [],
    amazonS3List: [],
    googleDriveList: [],
    ftpList: [],
    whatsappList: [],
    whatsappContentList: [],
    payGateList: [],
    emailList: [],
    // outEmailContentList: [],
    pmsList: [],
    socialNetworkList: [],
    emailContentData: [],
    xpressConnectList: [],
    userStoreList: [],
    ivrList: [],
}
const mutations = {
    CLEAR_SMS_STATE(state) {
        state.smsList = [];
        state.smsContentList = [];
    },
    CLEAR_OTT_STATE(state) {
        state.ottList = [];
    },
    CLEAR_ENACH_STATE(state) {
        state.enachList = [];
    },
    CLEAR_AADHAARKYC_STATE(state) {
        state.aadhaarkycList = [];
    },
    CLEAR_IVR_STATE(state) {
        state.ivrList = [];
    },
    CLEAR_IPPHONE_STATE(state) {
        state.ipPhoneList = [];
        state.smsContentList = [];
    },
    CLEAR_IPTV_STATE(state) {
        state.iptvList = [];
        state.iptvContentList = [];
    },
    CLEAR_QUICKBOOK_STATE(state) {
        state.quickBookList = [];
    },
    CLEAR_WEBHOOKS_STATE(state) {
        state.webHooksList = [];
    },
    CLEAR_ONE_SIGNAL_STATE(state) {
        state.oneSignalList = [];
    },
    CLEAR_AMAZONS3_STATE(state) {
        state.amazonS3List = [];
    },
    CLEAR_GOOGLE_DRIVE_STATE(state) {
        state.googleDriveList = [];
    },
    CLEAR_FTP_STATE(state) {
        state.ftpList = [];
    },
    CLEAR_WHATSAPP_STATE(state) {
        state.whatsappList = [];
        state.whatsappContentList = [];
    },
    CLEAR_PAYMENT_GATEWAY_STATE(state) {
        state.payGateList = [];
    },
    CLEAR_EMAIL_STATE(state) {
        state.emailList = [];
        // state.outEmailContentList = [];
    },
    CLEAR_PMS_STATE(state) {
        state.pmsList = [];
    },
    CLEAR_SOCIAL_NETWORK_STATE(state) {
        state.socialNetworkList = [];
    },
    SET_XPRESS_CONNECT_LIST(state, xpressConnectData) {
        var tData = {};
        var parseData = xpressConnectData.message;
        if (Object.keys(state.xpressConnectList).length == 0) {
            tData[xpressConnectData.accountId + '-xpressConnectList'] = parseData;
            state.xpressConnectList = tData;
        } else {
            Vue.set(state.xpressConnectList, xpressConnectData.accountId + '-xpressConnectList', parseData);
        }
    },
    SET_USER_STORE_LIST(state, userStoreData) {
        var tData = {};
        var parseData = userStoreData.message;
        if (Object.keys(state.userStoreList).length == 0) {
            tData[userStoreData.accountId + '-userStoreList'] = parseData;
            state.userStoreList = tData;
        } else {
            Vue.set(state.userStoreList, userStoreData.accountId + '-userStoreList', parseData);
        }
    },
    SET_SMS_DETAILS(state, smsData) {
        var tData = {};
        var parseData = smsData.message;
        if (Object.keys(state.smsList).length == 0) {
            tData[smsData.accountId + '-smsList'] = parseData;
            state.smsList = tData;
        } else {
            Vue.set(state.smsList, smsData.accountId + '-smsList', parseData);
        }
    },
    SET_SMS_CONTENT(state, smsData) {
        var tData = {};
        var parseData = smsData.message;
        if (Object.keys(state.smsContentList).length == 0) {
            tData[smsData.accountId + '-smsContentList'] = parseData;
            state.smsContentList = tData;
        } else {
            Vue.set(state.smsContentList, smsData.accountId + '-smsContentList', parseData);
        }
    },
    SET_EMAIL_CONTENT(state, smsData) {
        var tData = {};
        var parseData = smsData.message;
        // if (Object.keys(state.emailContentData).length == 0) {
        tData[smsData.accountId + '-emailContentList'] = parseData;
        state.emailContentData = tData;
        // } else {
        //     Vue.set(state.emailContentData, smsData.accountId + '-emailContentList', parseData);
        // }
    },
    UPDATE_EMAIL_CONTENT(state, emailData) {
        var allData = emailData.allData;
        var accountId = emailData.accountId;
        var tempName = allData.templateName;
        var emailName = allData.emailName;
        var custTemp = allData.customDataobj;
        if (Object.keys(state.emailContentData).length != 0) {
            if (emailData.custom == 'no') {
                if (state.emailContentData[accountId + "-emailContentList"].contentKeys[tempName].name == emailName) {
                    state.emailContentData[accountId + "-emailContentList"][tempName + "Values"].content = allData.content;
                    state.emailContentData[accountId + "-emailContentList"][tempName + "Values"].footer = allData.footer;
                    state.emailContentData[accountId + "-emailContentList"][tempName + "Values"].header = allData.header;
                    state.emailContentData[accountId + "-emailContentList"][tempName + "ContentDisable"] = !allData.disable;
                    if (allData.type == true) {
                        var type = 'html';
                    } else {
                        var type = 'text';
                    }
                    state.emailContentData[accountId + "-emailContentList"][tempName + "Values"].type = type;
                }
            } else {
                tempName = custTemp.name;
                var index = state.emailContentData[accountId + "-emailContentList"].customTemplates.findIndex(data => data.name == tempName);
                if (index != '-1') {
                    state.emailContentData[accountId + "-emailContentList"].customTemplates.splice(index, 1)
                }
                var custData = {};
                custData.content = custTemp.summernoteContent;
                if (custTemp.templateChecked == 1) {
                    var disable = true;
                } else {
                    var disable = false;
                }
                custData.disable = disable;
                custData.name = custTemp.name;
                custData.templateName = allData.custName;
                if (custTemp.htmlTemplatechecked == 1) {
                    var type = 'html';
                } else {
                    var type = 'text';
                }
                custData.type = type;
                state.emailContentData[accountId + "-emailContentList"].customTemplates.push(custData);
                if (state.emailContentData[accountId + "-emailContentList"].customContentKeys[tempName].name == allData.custName) {
                    state.emailContentData[accountId + "-emailContentList"]["customTemplateDetails"][tempName + "Values"].content = custData.content;
                    state.emailContentData[accountId + "-emailContentList"]["customTemplateDetails"][tempName + "Values"].type = type;
                    state.emailContentData[accountId + "-emailContentList"]["customTemplateDetails"][tempName + "ContentDisable"] = !disable;
                }
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-emailContentList"][tempName + "Values"].content = allData.content;
            dataSet[accountId + "-emailContentList"][tempName + "ContentDisable"] = allData.disable;
            if (allData.type == true) {
                var type = 'html';
            } else {
                var type = 'text';
            }
            dataSet[accountId + "-emailContentList"][tempName + "Values"].type = type;
            state.emailContentData = dataSet;
        }
    },
    ADD_SMS_LIST(state, data) {
        var smsData = data.smsData;
        var accountId = data.accountId;
        if (Object.keys(state.smsList).length != 0 && state.smsList != 'noData') {
            if (state.smsList != 'noData') {
                var index = state.smsList[accountId + "-smsList"].gateways.findIndex(sms => sms.name == smsData.oldName);
                if (index != '-1') {
                    state.smsList[accountId + "-smsList"].gateways.splice(index, 1)
                }
                state.smsList[accountId + "-smsList"].gateways.push(smsData);
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-smsList"].gateways = smsData;
            state.smsList = dataSet;
        }
    },
    DELETE_SMS_LIST(state, data) {
        var smsIds = data.smsData;
        var accountId = data.accountId;
        if (Object.keys(state.smsList).length != 0) {
            var index = state.smsList[accountId + "-smsList"].gateways.findIndex(sms => sms.name == smsIds);
            if (index != '-1') {
                state.smsList[accountId + "-smsList"].gateways.splice(index, 1)
            }
        }
    },
    UPDATE_SMS_CONTENT(state, smsData) {
        var allData = smsData.allData;
        var accountId = allData.accountId;
        var tempName = allData.templateName;
        var smsName = allData.smsName;
        if (Object.keys(state.smsContentList).length != 0) {
            if (tempName.substr(0, 6) == "custom") {
                if (state.smsContentList[accountId + "-smsContentList"].customContentKeys[tempName].name == smsName) {
                    state.smsContentList[accountId + "-smsContentList"]["customTemplateDetails"][tempName + "Values"].content = allData.content;
                    state.smsContentList[accountId + "-smsContentList"]["customTemplateDetails"][tempName + "Values"].footer = allData.footer;
                    state.smsContentList[accountId + "-smsContentList"]["customTemplateDetails"][tempName + "Values"].templateRegistrationNumber = allData.templateRegistrationNumber;
                    state.smsContentList[accountId + "-smsContentList"]["customTemplateDetails"][tempName + "ContentDisable"] = allData.tempDis;
                }
            } else {
                if (state.smsContentList[accountId + "-smsContentList"].contentKeys[tempName].name == smsName) {
                    state.smsContentList[accountId + "-smsContentList"][tempName + "Values"].content = allData.content;
                    state.smsContentList[accountId + "-smsContentList"][tempName + "Values"].footer = allData.footer;
                    state.smsContentList[accountId + "-smsContentList"][tempName + "Values"].templateRegistrationNumber = allData.templateRegistrationNumber;
                    state.smsContentList[accountId + "-smsContentList"][tempName + "ContentDisable"] = allData.tempDis;
                }
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-smsContentList"][tempName + "Values"].content = allData.content;
            dataSet[accountId + "-smsContentList"][tempName + "ContentDisable"] = allData.tempDis;
            state.smsContentList = dataSet;
        }
    },
    UPDATE_CUSTOM_SMS_CONTENT_LIST(state, data) {
        var smsContentData = data.smsContentData.customTemplateDetails;
        var smsContentKeyData = data.smsContentData.customContentKeys;
        var accountId = data.accountId;
        var obj = {};
        if (Object.keys(state.smsContentList).length != 0 && state.smsContentList != 'noData') {
            if (state.smsContentList != 'noData') {
                var accId = accountId + "-smsContentList";
                Vue.set(state.smsContentList[accId], "customContentKeys", smsContentKeyData);
                Vue.set(state.smsContentList[accId], "customTemplateDetails", smsContentData);
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-smsContentList"].customTemplateDetails = smsContentData;
            dataSet[accountId + "-smsContentList"].customContentKeys = smsContentKeyData;
            state.smsContentList = dataSet;
        }
    },
    SET_OTT_DETAILS(state, ottData) {
        var tData = {};
        var parseData = ottData.message;
        if (Object.keys(state.ottList).length == 0) {
            tData[ottData.accountId + '-ottList'] = parseData;
            state.ottList = tData;
        } else {
            Vue.set(state.ottList, ottData.accountId + '-ottList', parseData);
        }
    },
    SET_ENACH_DETAILS(state, enachData) {
        var tData = {};
        var parseData = enachData.message;
        if (Object.keys(state.enachList).length == 0) {
            tData[enachData.accountId + '-enachList'] = parseData;
            state.enachList = tData;
        } else {
            Vue.set(state.enachList, enachData.accountId + '-enachList', parseData);
        }
    },
    SET_AADHAARKYC_DETAILS(state, aadhaarkycData) {
        var tData = {};
        var parseData = aadhaarkycData.message;
        if (Object.keys(state.aadhaarkycList).length == 0) {
            tData[aadhaarkycData.accountId + '-aadhaarkycList'] = parseData;
            state.aadhaarkycList = tData;
        } else {
            Vue.set(state.aadhaarkycList, aadhaarkycData.accountId + '-aadhaarkycList', parseData);
        }
    },
    DELETE_OTT_LIST(state, data) {
        var ottIds = data.ottData;
        var accountId = data.accountId;

        if (Object.keys(state.ottList).length != 0) {
            var index = state.ottList[accountId + "-ottList"].gateways.findIndex(ott => ott.name == ottIds);
            if (index != '-1') {
                state.ottList[accountId + "-ottList"].gateways.splice(index, 1)
            }
        }
    },
    ADD_OTT_LIST(state, data) {
        var ottData = data.ottData;
        var accountId = data.accountId;
        if (Object.keys(state.ottList).length != 0 && state.ottList != 'noData') {
            if (state.ottList != 'noData') {
                var index = state.ottList[accountId + "-ottList"].gateways.findIndex(ott => ott.name == ottData.oldName);
                if (index != '-1') {
                    state.ottList[accountId + "-ottList"].gateways.splice(index, 1);
                }
                state.ottList[accountId + "-ottList"].gateways.push(ottData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-ottList"].gateways = ottData;
            state.ottList = dataSet;
        }
    },
    DELETE_ENACH_LIST(state, data) {
        var enachIds = data.enachData;
        var accountId = data.accountId;

        if (Object.keys(state.enachList).length != 0) {
            var index = state.enachList[accountId + "-enachList"].gateways.findIndex(enach => enach.name == enachIds);
            if (index != '-1') {
                state.enachList[accountId + "-enachList"].gateways.splice(index, 1)
            }
        }
    },
    ADD_ENACH_LIST(state, data) {
        var enachData = data.enachData;
        var accountId = data.accountId;
        if (Object.keys(state.enachList).length != 0 && state.enachList != 'noData') {
            if (state.enachList != 'noData') {
                var index = state.enachList[accountId + "-enachList"].gateways.findIndex(enach => enach.name == enachData.oldName);
                if (index != '-1') {
                    state.enachList[accountId + "-enachList"].gateways.splice(index, 1);
                }
                state.enachList[accountId + "-enachList"].gateways.push(enachData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-enachList"].gateways = ottData;
            state.enachList = dataSet;
        }
    },
    DELETE_AADHAARKYC_LIST(state, data) {
        var aadhaarkycIds = data.aadhaarkycData;
        var accountId = data.accountId;

        if (Object.keys(state.aadhaarkycList).length != 0) {
            var index = state.aadhaarkycList[accountId + "-aadhaarkycList"].gateways.findIndex(aadhaarkyc => aadhaarkyc.name == aadhaarkycIds);
            if (index != '-1') {
                state.aadhaarkycList[accountId + "-aadhaarkycList"].gateways.splice(index, 1)
            }
        }
    },
    ADD_AADHAARKYC_LIST(state, data) {
        var aadhaarkycData = data.aadhaarkycData;
        var accountId = data.accountId;
        if (Object.keys(state.aadhaarkycList).length != 0 && state.aadhaarkycList != 'noData') {
            if (state.aadhaarkycList != 'noData') {
                var index = state.aadhaarkycList[accountId + "-aadhaarkycList"].gateways.findIndex(aadhaarkyc => aadhaarkyc.name == aadhaarkycData.oldName);
                if (index != '-1') {
                    state.aadhaarkycList[accountId + "-aadhaarkycList"].gateways.splice(index, 1);
                }
                state.aadhaarkycList[accountId + "-aadhaarkycList"].gateways.push(aadhaarkycData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-aadhaarkycList"].gateways = ottData;
            state.aadhaarkycList = dataSet;
        }
    },
    SET_IPPHONE_DETAILS(state, ipPhoneData) {
        var tData = {};
        var parseData = ipPhoneData.message;
        if (Object.keys(state.ipPhoneList).length == 0) {
            tData[ipPhoneData.accountId + '-ipPhoneList'] = parseData;
            state.ipPhoneList = tData;
        } else {
            Vue.set(state.ipPhoneList, ipPhoneData.accountId + '-ipPhoneList', parseData);
        }
    },
    DELETE_IPPHONE_LIST(state, data) {
        var ipPhoneIds = data.ipPhoneData;
        var accountId = data.accountId;

        if (Object.keys(state.ipPhoneList).length != 0) {
            var index = state.ipPhoneList[accountId + "-ipPhoneList"].gateways.findIndex(ipp => ipp.name == ipPhoneIds);
            if (index != '-1') {
                state.ipPhoneList[accountId + "-ipPhoneList"].gateways.splice(index, 1)
            }
        }
    },
    ADD_IPPHONE_LIST(state, data) {
        var ipPhoneData = data.ipPhoneData;
        var accountId = data.accountId;
        if (Object.keys(state.ipPhoneList).length != 0 && state.ipPhoneList != 'noData') {
            if (state.ipPhoneList != 'noData') {
                var index = state.ipPhoneList[accountId + "-ipPhoneList"].gateways.findIndex(ipp => ipp.name == ipPhoneData.oldName);
                if (index != '-1') {
                    state.ipPhoneList[accountId + "-ipPhoneList"].gateways.splice(index, 1);
                }
                state.ipPhoneList[accountId + "-ipPhoneList"].gateways.push(ipPhoneData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-ipPhoneList"].gateways = ipPhoneData;
            state.ipPhoneList = dataSet;
        }
    },
    SET_IPPHONE_CONTENT(state, ipphoneData) {
        var tData = {};
        var parseData = ipphoneData.message;
        if (Object.keys(state.ipPhoneContentList).length == 0) {
            tData[ipphoneData.accountId + '-ipPhoneContentList'] = parseData;
            state.ipPhoneContentList = tData;
        } else {
            Vue.set(state.ipPhoneContentList, ipphoneData.accountId + '-ipPhoneContentList', parseData);
        }
    },
    UPDATE_IPPHONE_CONTENT(state, ipPhoneData) {
        var allData = ipPhoneData.allData;
        var accountId = allData.accountId;
        var tempName = allData.templateName;
        var ipPhoneName = allData.ipPhoneName;
        if (Object.keys(state.ipPhoneContentList).length != 0) {
            if (state.ipPhoneContentList[accountId + "-ipPhoneContentList"].contentKeys[tempName].name == ipPhoneName) {
                state.ipPhoneContentList[accountId + "-ipPhoneContentList"][tempName + "Values"].content = allData.content;
                state.ipPhoneContentList[accountId + "-ipPhoneContentList"][tempName + "Values"].footer = allData.footer;
                state.ipPhoneContentList[accountId + "-ipPhoneContentList"][tempName + "ContentDisable"] = allData.tempDis;
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-ipPhoneContentList"][tempName + "Values"].content = allData.content;
            dataSet[accountId + "-ipPhoneContentList"][tempName + "ContentDisable"] = allData.tempDis;
            state.ipPhoneContentList = dataSet;
        }
    },
    SET_IPTV_DETAILS(state, iptvData) {
        var tData = {};
        var parseData = iptvData.message;
        if (Object.keys(state.iptvList).length == 0) {
            tData[iptvData.accountId + '-iptvList'] = parseData;
            state.iptvList = tData;
        } else {
            Vue.set(state.iptvList, iptvData.accountId + '-iptvList', parseData);
        }
    },
    DELETE_IPTV_LIST(state, data) {
        var iptvIds = data.iptvData;
        var accountId = data.accountId;

        if (Object.keys(state.iptvList).length != 0) {
            var index = state.iptvList[accountId + "-iptvList"].gateways.findIndex(iptv => iptv.name == iptvIds);
            if (index != '-1') {
                state.iptvList[accountId + "-iptvList"].gateways.splice(index, 1)
            }
        }
    },
    SET_IPTV_CONTENT(state, iptvData) {
        var tData = {};
        var parseData = iptvData.message;
        if (Object.keys(state.iptvContentList).length == 0) {
            tData[iptvData.accountId + '-iptvContentList'] = parseData;
            state.iptvContentList = tData;
        } else {
            Vue.set(state.iptvContentList, iptvData.accountId + '-iptvContentList', parseData);
        }
    },
    UPDATE_IPTV_CONTENT(state, iptvData) {
        var allData = iptvData.allData;
        var accountId = allData.accountId;
        var tempName = allData.templateName;
        var iptvName = allData.iptvName;
        if (Object.keys(state.iptvContentList).length != 0) {
            if (state.iptvContentList[accountId + "-iptvContentList"].contentKeys[tempName].name == iptvName) {
                state.iptvContentList[accountId + "-iptvContentList"][tempName + "Values"].content = allData.content;
                state.iptvContentList[accountId + "-iptvContentList"][tempName + "Values"].footer = allData.footer;
                state.iptvContentList[accountId + "-iptvContentList"][tempName + "ContentDisable"] = allData.tempDis;
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-iptvContentList"][tempName + "Values"].content = allData.content;
            dataSet[accountId + "-iptvContentList"][tempName + "ContentDisable"] = allData.tempDis;
            state.iptvContentList = dataSet;
        }
    },
    ADD_IPTV_LIST(state, data) {
        var iptvData = data.iptvData;
        var accountId = data.accountId;
        if (Object.keys(state.iptvList).length != 0 && state.iptvList != 'noData') {
            if (state.iptvList != 'noData') {
                var index = state.iptvList[accountId + "-iptvList"].gateways.findIndex(iptv => iptv.name == iptvData.oldName);
                if (index != '-1') {
                    state.iptvList[accountId + "-iptvList"].gateways.splice(index, 1);
                }
                state.iptvList[accountId + "-iptvList"].gateways.push(iptvData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-iptvList"].gateways = iptvData;
            state.iptvList = dataSet;
        }
    },
    SET_QUICKBOOK_DETAILS(state, quickBookData) {
        var tData = {};
        var parseData = quickBookData.message;
        if (Object.keys(state.quickBookList).length == 0) {
            tData[quickBookData.accountId + '-quickBookList'] = parseData;
            state.quickBookList = tData;
        } else {
            Vue.set(state.quickBookList, quickBookData.accountId + '-quickBookList', parseData);
        }
    },
    DELETE_QUICKBOOK_LIST(state, data) {
        var quickbookIds = data.quickBookData;
        var accountId = data.accountId;

        if (Object.keys(state.quickBookList).length != 0) {
            var index = state.quickBookList[accountId + "-quickBookList"].quickbooks.findIndex(quickBook => quickBook.quickBookName == quickbookIds);
            if (index != '-1') {
                state.quickBookList[accountId + "-quickBookList"].quickbooks.splice(index, 1)
            }
        }
    },
    SET_WEBHOOKS_DETAILS(state, webHookData) {
        var tData = {};
        var parseData = webHookData.message;
        if (Object.keys(state.webHooksList).length == 0) {
            tData[webHookData.accountId + '-webHooksList'] = parseData;
            state.webHooksList = tData;
        } else {
            Vue.set(state.webHooksList, webHookData.accountId + '-webHooksList', parseData);
        }
    },
    SET_ONE_SIGNAL_DETAILS(state, oneSignalData) {
        var tData = {};
        var parseData = oneSignalData.message;
        if (Object.keys(state.oneSignalList).length == 0) {
            tData[oneSignalData.accountId + '-oneSignalList'] = parseData;
            state.oneSignalList = tData;
        } else {
            Vue.set(state.oneSignalList, oneSignalData.accountId + '-oneSignalList', parseData);
        }
    },
    ADD_ONE_SIGNAL_LIST(state, data) {
        var oneSignalData = data.oneSignalData;
        var accountId = data.accountId;
        if (Object.keys(state.oneSignalList).length != 0 && state.oneSignalList != 'noData') {
            if (state.oneSignalList != 'noData') {
                var index = state.oneSignalList[accountId + "-oneSignalList"].oneSignalApps.findIndex(oneSignal => oneSignal.appName == oneSignalData.oldName);
                if (index != '-1') {
                    state.oneSignalList[accountId + "-oneSignalList"].oneSignalApps.splice(index, 1);
                }
                state.oneSignalList[accountId + "-oneSignalList"].oneSignalApps.push(oneSignalData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-oneSignalList"].oneSignalApps = oneSignalData;
            state.oneSignalList = dataSet;
        }
    },
    DELETE_ONE_SIGNAL_LIST(state, data) {
        var oneSignalIds = data.oneSignalData;
        var accountId = data.accountId;

        if (Object.keys(state.oneSignalList).length != 0) {
            var index = state.oneSignalList[accountId + "-oneSignalList"].oneSignalApps.findIndex(oneSignal => oneSignal.appName == oneSignalIds);
            if (index != '-1') {
                state.oneSignalList[accountId + "-oneSignalList"].oneSignalApps.splice(index, 1)
            }
        }
    },
    SET_AMAZONS3_DETAILS(state, amazonS3data) {
        var tData = {};
        var parseData = amazonS3data.message;
        if (Object.keys(state.amazonS3List).length == 0) {
            tData[amazonS3data.accountId + '-amazonS3List'] = parseData;
            state.amazonS3List = tData;
        } else {
            Vue.set(state.amazonS3List, amazonS3data.accountId + '-amazonS3List', parseData);
        }
    },
    DELETE_AMAZONS3_LIST(state, data) {
        var amazonS3Ids = data.amazonS3Data;
        var accountId = data.accountId;

        if (Object.keys(state.amazonS3List).length != 0) {
            var index = state.amazonS3List[accountId + "-amazonS3List"].amazons3s.findIndex(amazonS3 => amazonS3.servername == amazonS3Ids);
            if (index != '-1') {
                state.amazonS3List[accountId + "-amazonS3List"].amazons3s.splice(index, 1)
            }
        }
    },
    ADD_AMAZONS3_LIST(state, data) {
        var amazonS3Data = data.amazonS3Data;
        var accountId = data.accountId;
        if (Object.keys(state.amazonS3List).length != 0 && state.amazonS3List != 'noData') {
            if (state.amazonS3List != 'noData') {
                var index = state.amazonS3List[accountId + "-amazonS3List"].amazons3s.findIndex(amazonS3 => amazonS3.servername == amazonS3Data.oldName);
                if (index != '-1') {
                    state.amazonS3List[accountId + "-amazonS3List"].amazons3s.splice(index, 1);
                }
                state.amazonS3List[accountId + "-amazonS3List"].amazons3s.push(amazonS3Data);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-amazonS3List"].amazons3s = amazonS3Data;
            state.amazonS3List = dataSet;
        }
    },
    SET_GOOGLE_DRIVE_DETAILS(state, googleDriveData) {
        var tData = {};
        var parseData = googleDriveData.message;
        if (Object.keys(state.googleDriveList).length == 0) {
            tData[googleDriveData.accountId + '-googleDriveList'] = parseData;
            state.googleDriveList = tData;
        } else {
            Vue.set(state.googleDriveList, googleDriveData.accountId + '-googleDriveList', parseData);
        }
    },
    DELETE_GOOGLE_DRIVE_LIST(state, data) {
        var googleDriveIds = data.googleDriveData;
        var accountId = data.accountId;

        if (Object.keys(state.googleDriveList).length != 0) {
            var index = state.googleDriveList[accountId + "-googleDriveList"].googledrives.findIndex(googleDrive => googleDrive.googleDriveName == googleDriveIds);
            if (index != '-1') {
                state.googleDriveList[accountId + "-googleDriveList"].googledrives.splice(index, 1)
            }
        }
    },
    SET_FTP_DETAILS(state, ftpData) {
        var tData = {};
        var parseData = ftpData.message;
        if (Object.keys(state.ftpList).length == 0) {
            tData[ftpData.accountId + '-ftpList'] = parseData;
            state.ftpList = tData;
        } else {
            Vue.set(state.ftpList, ftpData.accountId + '-ftpList', parseData);
        }
    },
    ADD_FTP_LIST(state, data) {
        var ftpData = data.ftpData;
        var accountId = data.accountId;
        if (Object.keys(state.ftpList).length != 0 && state.ftpList != 'noData') {
            if (state.ftpList != 'noData') {
                var index = state.ftpList[accountId + "-ftpList"].ftps.findIndex(ftp => ftp.servername == ftpData.oldName);
                if (index != '-1') {
                    state.ftpList[accountId + "-ftpList"].ftps.splice(index, 1);
                }
                state.ftpList[accountId + "-ftpList"].ftps.push(ftpData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-ftpList"].ftps = ftpData;
            state.ftpList = dataSet;
        }
    },
    DELETE_FTP_LIST(state, data) {
        var ftpIds = data.ftpData;
        var accountId = data.accountId;

        if (Object.keys(state.ftpList).length != 0) {
            var index = state.ftpList[accountId + "-ftpList"].ftps.findIndex(ftp => ftp.servername == ftpIds);
            if (index != '-1') {
                state.ftpList[accountId + "-ftpList"].ftps.splice(index, 1)
            }
        }
    },
    SET_WHATSAPP_DETAILS(state, whatsappData) {
        var tData = {};
        var parseData = whatsappData.message;
        if (Object.keys(state.whatsappList).length == 0) {
            tData[whatsappData.accountId + '-whatsappList'] = parseData;
            state.whatsappList = tData;
        } else {
            Vue.set(state.whatsappList, whatsappData.accountId + '-whatsappList', parseData);
        }
    },
    SET_WHATSAPP_CONTENT(state, whatsappData) {
        var tData = {};
        var parseData = whatsappData.message;
        if (Object.keys(state.whatsappContentList).length == 0) {
            tData[whatsappData.accountId + '-whatsappContentList'] = parseData;
            state.whatsappContentList = tData;
        } else {
            Vue.set(state.whatsappContentList, whatsappData.accountId + '-whatsappContentList', parseData);
        }
    },
    ADD_WHATSAPP_LIST(state, data) {
        var whatsappData = data.whatsappData;
        var accountId = data.accountId;
        if (Object.keys(state.whatsappList).length != 0 && state.whatsappList != 'noData') {
            if (state.whatsappList != 'noData') {
                var index = state.whatsappList[accountId + "-whatsappList"].gateways.findIndex(whatsapp => whatsapp.name == whatsappData.oldName);
                if (index != '-1') {
                    state.whatsappList[accountId + "-whatsappList"].gateways.splice(index, 1)
                }
                state.whatsappList[accountId + "-whatsappList"].gateways.push(whatsappData);
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-whatsappList"].gateways = whatsappData;
            state.whatsappList = dataSet;
        }
    },
    DELETE_WHATSAPP_LIST(state, data) {
        var whatsappIds = data.whatsappData;
        var accountId = data.accountId;
        if (Object.keys(state.whatsappList).length != 0) {
            var index = state.whatsappList[accountId + "-whatsappList"].gateways.findIndex(whatsapp => whatsapp.name == whatsappIds);
            if (index != '-1') {
                state.whatsappList[accountId + "-whatsappList"].gateways.splice(index, 1)
            }
        }
    },
    UPDATE_WHATSAPP_CONTENT(state, whatsappData) {
        var allData = whatsappData.allData;
        var accountId = allData.accountId;
        var tempName = allData.templateName;
        var whatsappName = allData.whatsappName;
        if (Object.keys(state.whatsappContentList).length != 0) {
            if (tempName.substr(0, 6) == "custom") {
                if (state.whatsappContentList[accountId + "-whatsappContentList"].customContentKeys[tempName].name == whatsappName) {
                    state.whatsappContentList[accountId + "-whatsappContentList"]["customTemplateDetails"][tempName + "Values"].content = allData.content;
                    state.whatsappContentList[accountId + "-whatsappContentList"]["customTemplateDetails"][tempName + "Values"].footer = allData.footer;
                    state.whatsappContentList[accountId + "-whatsappContentList"]["customTemplateDetails"][tempName + "Values"].bussinessName = allData.bussinessName;
                    state.whatsappContentList[accountId + "-whatsappContentList"]["customTemplateDetails"][tempName + "ContentDisable"] = allData.tempDis;
                }
            } else {
                if (state.whatsappContentList[accountId + "-whatsappContentList"].contentKeys[tempName].name == whatsappName) {
                    state.whatsappContentList[accountId + "-whatsappContentList"][tempName + "Values"].content = allData.content;
                    state.whatsappContentList[accountId + "-whatsappContentList"][tempName + "Values"].footer = allData.footer;
                    state.whatsappContentList[accountId + "-whatsappContentList"][tempName + "Values"].bussinessName = allData.bussinessName;
                    state.whatsappContentList[accountId + "-whatsappContentList"][tempName + "ContentDisable"] = allData.tempDis;
                }
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-whatsappContentList"][tempName + "Values"].content = allData.content;
            dataSet[accountId + "-whatsappContentList"][tempName + "ContentDisable"] = allData.tempDis;
            state.whatsappContentList = dataSet;
        }
    },
    UPDATE_CUSTOM_WHATSAPP_CONTENT_LIST(state, data) {
        var whatsappContentData = data.whatsappContentData.customTemplateDetails;
        var whatsappContentKeyData = data.whatsappContentData.customContentKeys;
        var accountId = data.accountId;
        var obj = {};
        if (Object.keys(state.whatsappContentList).length != 0 && state.whatsappContentList != 'noData') {
            if (state.whatsappContentList != 'noData') {
                var accId = accountId + "-whatsappContentList";
                Vue.set(state.whatsappContentList[accId], "customContentKeys", whatsappContentKeyData);
                Vue.set(state.whatsappContentList[accId], "customTemplateDetails", whatsappContentData);
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-whatsappContentList"].customTemplateDetails = whatsappContentData;
            dataSet[accountId + "-whatsappContentList"].customContentKeys = whatsappContentKeyData;
            state.whatsappContentList = dataSet;
        }
    },
    SET_PAYMENT_GATEWAY_DETAILS(state, payGateData) {
        var tData = {};
        var parseData = payGateData.message;
        if (Object.keys(state.payGateList).length == 0) {
            tData[payGateData.accountId + '-payGateList'] = parseData;
            state.payGateList = tData;
        } else {
            Vue.set(state.payGateList, payGateData.accountId + '-payGateList', parseData);
        }
    },
    DELETE_PAYMENT_GATEWAY_LIST(state, data) {
        var payGateIds = data.payGateData;
        var accountId = data.accountId;

        if (Object.keys(state.payGateList).length != 0) {
            var index = state.payGateList[accountId + "-payGateList"].gateways.findIndex(payGate => payGate.name == payGateIds);
            if (index != '-1') {
                state.payGateList[accountId + "-payGateList"].gateways.splice(index, 1)
            }
        }
    },
    ADD_PAYMENT_GATEWAY_LIST(state, data) {
        var payGateData = data.payGateData;
        var accountId = data.accountId;
        if (Object.keys(state.payGateList).length != 0 && state.payGateList != 'noData') {
            if (state.payGateList != 'noData') {
                var index = state.payGateList[accountId + "-payGateList"].gateways.findIndex(payGate => payGate.name == payGateData.oldName);
                if (index != '-1') {
                    state.payGateList[accountId + "-payGateList"].gateways.splice(index, 1);
                }
                state.payGateList[accountId + "-payGateList"].gateways.push(payGateData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-payGateList"].gateways = payGateData;
            state.payGateList = dataSet;
        }
    },
    SET_EMAIL_DETAILS(state, emailData) {
        var tData = {};
        var parseData = emailData.message;
        if (Object.keys(state.emailList).length == 0) {
            tData[emailData.accountId + '-emailList'] = parseData;
            state.emailList = tData;
        } else {
            Vue.set(state.emailList, emailData.accountId + '-emailList', parseData);
        }
    },
    ADD_INBOUND_EMAIL_LIST(state, data) {
        var inEmailData = data.inEmailData;
        var accountId = data.accountId;
        if (Object.keys(state.emailList).length != 0 && state.emailList != 'noData') {
            if (state.emailList != 'noData') {
                var index = state.emailList[accountId + "-emailList"].inboundEmailGateways.findIndex(inEmail => inEmail.name == inEmailData.oldName);
                if (index != '-1') {
                    state.emailList[accountId + "-emailList"].inboundEmailGateways.splice(index, 1);
                }
                state.emailList[accountId + "-emailList"].inboundEmailGateways.push(inEmailData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-emailList"].inboundEmailGateways = inEmailData;
            state.emailList = dataSet;
        }
    },
    ADD_OUTBOUND_EMAIL_LIST(state, data) {
        var outEmailData = data.outEmailData;
        var accountId = data.accountId;
        if (Object.keys(state.emailList).length != 0 && state.emailList != 'noData') {
            if (state.emailList != 'noData') {
                var index = state.emailList[accountId + "-emailList"].gateways.findIndex(outEmail => outEmail.name == outEmailData.oldName);
                if (index != '-1') {
                    state.emailList[accountId + "-emailList"].gateways.splice(index, 1);
                }
                state.emailList[accountId + "-emailList"].gateways.push(outEmailData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-emailList"].gateways = outEmailData;
            state.emailList = dataSet;
        }
    },
    DELETE_OUTBOUND_EMAIL_LIST(state, data) {
        var outEmailIds = data.outEmailData;
        var accountId = data.accountId;

        if (Object.keys(state.emailList).length != 0) {
            var index = state.emailList[accountId + "-emailList"].gateways.findIndex(outEmail => outEmail.name == outEmailIds);
            if (index != '-1') {
                state.emailList[accountId + "-emailList"].gateways.splice(index, 1)
            }
        }
    },
    DELETE_INBOUND_EMAIL_LIST(state, data) {
        var inEmailIds = data.inEmailData;
        var accountId = data.accountId;

        if (Object.keys(state.emailList).length != 0) {
            var index = state.emailList[accountId + "-emailList"].inboundEmailGateways.findIndex(inEmail => inEmail.name == inEmailIds);
            if (index != '-1') {
                state.emailList[accountId + "-emailList"].inboundEmailGateways.splice(index, 1)
            }
        }
    },
    CLEAR_EMAIL_CONTENT(state, data) {
        state.emailContentData = []
    },
    SET_PMS_DETAILS(state, pmsData) {
        var tData = {};
        var parseData = pmsData.message;
        if (Object.keys(state.pmsList).length == 0) {
            tData[pmsData.accountId + '-pmsList'] = parseData;
            state.pmsList = tData;
        } else {
            Vue.set(state.pmsList, pmsData.accountId + '-pmsList', parseData);
        }
    },
    SET_SOCIAL_NETWORKS_DETAILS(state, socialNetworkData) {
        var tData = {};
        var parseData = socialNetworkData.message;
        if (Object.keys(state.socialNetworkList).length == 0) {
            tData[socialNetworkData.accountId + '-socialNetworkList'] = parseData;
            state.socialNetworkList = tData;
        } else {
            Vue.set(state.socialNetworkList, socialNetworkData.accountId + '-socialNetworkList', parseData);
        }
    },
    SET_IVR_DETAILS(state, ivrData) {
        var tData = {};
        var parseData = ivrData.message;
        if (Object.keys(state.ivrList).length == 0) {
            tData[ivrData.accountId + '-ivrList'] = parseData;
            state.ivrList = tData;
        } else {
            Vue.set(state.ivrList, ivrData.accountId + '-ivrList', parseData);
        }
    },
    ADD_IVR_LIST(state, data) {
        var ivrData = data.ivrData;
        var accountId = data.accountId;
        if (Object.keys(state.ivrList).length != 0 && state.ivrList != 'noData') {
            if (state.ivrList != 'noData') {
                var index = state.ivrList[accountId + "-ivrList"].gateways.findIndex(ivr => ivr.name == ivrData.oldName);
                if (index != '-1') {
                    state.ivrList[accountId + "-ivrList"].gateways.splice(index, 1);
                }
                state.ivrList[accountId + "-ivrList"].gateways.push(ivrData);

            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-ivrList"].gateways = ivrData;
            state.ivrList = dataSet;
        }
    },
    DELETE_IVR_LIST(state, data) {
        var ivrIds = data.ivrData;
        var accountId = data.accountId;

        if (Object.keys(state.ivrList).length != 0) {
            var index = state.ivrList[accountId + "-ivrList"].gateways.findIndex(ivr => ivr.name == ivrIds);
            if (index != '-1') {
                state.ivrList[accountId + "-ivrList"].gateways.splice(index, 1)
            }
        }
    },
}
const actions = {
    clearSmsState({
        commit,
        dispatch
    }) {
        commit('CLEAR_SMS_STATE')
    },
    clearOttState({
        commit,
        dispatch
    }) {
        commit('CLEAR_OTT_STATE')
    },
    clearEnachState({
        commit,
        dispatch
    }) {
        commit('CLEAR_ENACH_STATE')
    },
    clearAadhaarkycState({
        commit,
        dispatch
    }) {
        commit('CLEAR_AADHAARKYC_STATE')
    },
    clearIvrState({
        commit,
        dispatch
    }) {
        commit('CLEAR_IVR_STATE')
    },
    clearIpPhoneState({
        commit,
        dispatch
    }) {
        commit('CLEAR_IPPHONE_STATE')
    },
    clearIptvState({
        commit,
        dispatch
    }) {
        commit('CLEAR_IPTV_STATE')
    },
    clearQuickBookState({
        commit,
        dispatch
    }) {
        commit('CLEAR_QUICKBOOK_STATE')
    },
    clearWebHooksState({
        commit,
        dispatch
    }) {
        commit('CLEAR_WEBHOOKS_STATE')
    },
    clearOneSignalState({
        commit,
        dispatch
    }) {
        commit('CLEAR_ONE_SIGNAL_STATE')
    },
    clearAmazonS3State({
        commit,
        dispatch
    }) {
        commit('CLEAR_AMAZONS3_STATE')
    },
    clearGoogleDriveState({
        commit,
        dispatch
    }) {
        commit('CLEAR_GOOGLE_DRIVE_STATE')
    },
    clearFtpState({
        commit,
        dispatch
    }) {
        commit('CLEAR_FTP_STATE')
    },
    clearWhatsappState({
        commit,
        dispatch
    }) {
        commit('CLEAR_WHATSAPP_STATE')
    },
    clearPayGateState({
        commit,
        dispatch
    }) {
        commit('CLEAR_PAYMENT_GATEWAY_STATE')
    },
    clearEmailState({
        commit,
        dispatch
    }) {
        commit('CLEAR_EMAIL_STATE')
    },
    clearPmsState({
        commit,
        dispatch
    }) {
        commit('CLEAR_PMS_STATE')
    },
    clearSocialNetworkState({
        commit,
        dispatch
    }) {
        commit('CLEAR_SOCIAL_NETWORK_STATE')
    },
    clearemailContent({
        commit,
        dispatch
    }) {
        commit('CLEAR_EMAIL_CONTENT')
    },
    fetchUserStoreDetails({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/external_integration/user_store/true')
                .then(res => {
                    Nprogress.done()
                    commit('SET_USER_STORE_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchXpressConnectDetails({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/external_integration/xpress_connect/true')
                .then(res => {
                    Nprogress.done()
                    commit('SET_XPRESS_CONNECT_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchSmsDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/customize_user_request_access/customize_sms_settings/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_SMS_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    fetchSmsContent({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/captive_portal/customize_sms_content/true")
            .then(response => {
                Nprogress.done()
                commit('SET_SMS_CONTENT', response.data)
            })
            .catch(error => console.log(error))
    },
    fetchEmailContent({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/captive_portal/customize_email_content/true")
            .then(response => {
                Nprogress.done()
                commit('SET_EMAIL_CONTENT', response.data)
            })
            .catch(error => console.log(error))
    },
    xpressConnectSubmit({
        commit,
        dispatch
    }, formData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/xpress_connect_post', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })

                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    addEditLdapFormSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_edit_ldap_save', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteUserStoreFormSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/delete_user_store', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    createSmsModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_default_operator', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        smsData: response.data.smsData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_SMS_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteSmsGatewaySubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/customize_user_request_access/delete_sms_gateway/' + authData.smsIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        smsData: response.data.smsGatewayName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_SMS_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultSmsGatewaySubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/customize_user_request_access/make_default_sms_gateway/' + authData.smsIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addSmsToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/add_all_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveSmsContent({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_sms_contents/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        allData: postData,
                        // smsContentData: response.data.smsContentData,
                        // accountId: response.data.accountId,
                        // smsName: postData.smsName,
                        // tempName: postData.templateName
                    }
                    commit('UPDATE_SMS_CONTENT', dataList);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addCustomSmsTemplate({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_custom_sms_contents', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        smsContentData: response.data,
                        accountId: response.data.accountId
                    }
                    commit('UPDATE_CUSTOM_SMS_CONTENT_LIST', dataList);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    exportSmsCsv({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/exportSmsCsv', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteCustomSmsTemplate({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/delete_custom_sms_template', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        smsContentData: response.data.smsContentData,
                        accountId: response.data.accountId
                    }
                    // commit('DELETE_SMS_CONTENT_LIST', dataList);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchOttDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/customize_ott/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_OTT_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createEnachModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_enach', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        enachData: response.data.enachData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_ENACH_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    createAadhaarkycModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_aadhaarkyc', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        aadhaarkycData: response.data.aadhaarkycData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_AADHAARKYC_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchEnachDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/customize_enach/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_ENACH_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    fetchAadhaarkycDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/customize_aadhaarkyc/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_AADHAARKYC_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createOttModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_ott', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        ottData: response.data.ottData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_OTT_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultEnachSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/make_default_enach/' + authData.enachIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultAadhaarkycSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/make_default_aadhaarkyc/' + authData.aadhaarkycIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultOttSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/make_default_ott/' + authData.ottIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addOttToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_all_ott_sub_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_sub_accounts_cannot_change_ott_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteOttSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_ott/' + authData.ottIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        ottData: response.data.ottGatewayName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_OTT_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addEnachToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_all_enach_sub_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    addAadhaarkycToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_all_aadhaarkyc_sub_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveSubAccEnachSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_sub_accounts_cannot_change_enach_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveSubAccAadhaarkycSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_sub_accounts_cannot_change_aadhaarkyc_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteEnachSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_enach/' + authData.ottIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        enachData: response.data.enachGatewayName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_ENACH_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteAadhaarkycSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_aadhaarkyc/' + authData.aadhaarkycIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        aadhaarkycData: response.data.aadhaarkycGatewayName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_AADHAARKYC_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchIpPhoneDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/customize_ipphone/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_IPPHONE_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createIpPhoneModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_ipphone', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        ipPhoneData: response.data.ipPhoneData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_IPPHONE_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultIpPhoneSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/make_default_ipphone/' + authData.ippIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    syncIpPhoneToUsers({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/sync_users_nexge', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveIpPhoneSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_sub_accounts_cannot_change_ipphone_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    addIpPhoneToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_all_ipphone_sub_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteIpPhoneSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_ipphone/' + authData.ippIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        ipPhoneData: response.data.ipPhoneGatewayName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_IPPHONE_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveIpPhoneContent({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_ipphone_contents/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        allData: postData,
                        // ipPhoneContentData: response.data.ipPhoneContentData,
                        // accountId: response.data.accountId
                    }
                    commit('UPDATE_IPPHONE_CONTENT', dataList);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchIpPhoneContent({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/captive_portal/customize_ipphone_content/true")
            .then(response => {
                Nprogress.done()
                commit('SET_IPPHONE_CONTENT', response.data)
            })
            .catch(error => console.log(error))
    },
    fetchIptvDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/customize_iptv/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_IPTV_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    makeDefaultIptvSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/make_default_iptv/' + authData.iptvIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveIptvSubAccountSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_sub_accounts_cannot_change_iptv_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    addIptvToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_all_iptv_sub_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteIptvSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_iptv/' + authData.iptvIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        iptvData: response.data.iptvName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_IPTV_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    createIptvModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_iptv', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        iptvData: response.data.iptvData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_IPTV_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchIptvContent({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/captive_portal/customize_iptv_content/true")
            .then(response => {
                Nprogress.done()
                commit('SET_IPTV_CONTENT', response.data)
            })
            .catch(error => console.log(error))
    },
    saveIptvContent({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_iptv_contents/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        allData: postData,
                        // iptvContentData: response.data.iptvContentData,
                        // accountId: response.data.accountId
                    }
                    commit('UPDATE_IPTV_CONTENT', dataList);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },

    fetchQuickBookDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/quickbooks/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_QUICKBOOK_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    fetchAddEditQuickBookDetails({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/getquickbookDetails', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    addQuickBookToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_quickbooks_settings_subzones', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveQuickBookSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/subacc_cannotchange_quickbookssettings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteQuickBookSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_quickbook/' + authData.quickBookIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        quickBookData: response.data.quickBookName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_QUICKBOOK_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    createQuickBookModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_quickbooks', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status == "AuthRedirect") {
                        window.location.href = response.data.authUrl;
                    }
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }


                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchWebHooksDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/web_hooks/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_WEBHOOKS_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    addWebHooksToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_web_hooks_all_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    createWebHooksModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/web_hooks/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }


                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchOneSignalDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/one_signal/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_ONE_SIGNAL_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    saveOneSignalSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/subAccCannotChangeOneSignalAppSettings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.alertGoogleText);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    addOneSignalToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/addOneSignalAppsSettingsSubZones', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteOneSignalSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_one_signal_app/' + authData.oneSignalIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        oneSignalData: response.data.oneSignalName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_ONE_SIGNAL_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchAddEditOneSignalDetails({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/getOneSignalAppDetails', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    createOneSignalModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_edit_OneSignalApp', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        oneSignalData: response.data.oneSignalData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_ONE_SIGNAL_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchAmazonS3Details({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/amazon_s3/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_AMAZONS3_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    saveAmazonS3SubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/subacc_cannotchange_amazons3settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    addAmazonS3ToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_amazonS3_settings_subzones', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteAmazonS3Submit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_amazon_s3/' + authData.amazonS3Index)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        amazonS3Data: response.data.amazonS3Name,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_AMAZONS3_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchAddEditAmazonS3Details({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/get_amazonS3_details', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    createAmazonS3ModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_edit_amazon_s3', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        amazonS3Data: response.data.amazonS3Data,
                        accountId: response.data.accountId
                    }
                    commit('ADD_AMAZONS3_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchGoogleDriveDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/googledrive/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_GOOGLE_DRIVE_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    fetchAddEditGoogleDriveDetails({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/getgoogledriveDetails', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    addGoogleDriveToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/addDriveSettingsSubZones', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveGoogleDriveSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/subAccCannotChangeGoogleDriveSettings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteGoogleDriveSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/deletegoogledrive/' + authData.googleDriveIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        googleDriveData: response.data.googleDriveName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_GOOGLE_DRIVE_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    createGoogleDriveModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/addGoogleDrive', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status == "AuthRedirect") {
                        window.location.href = response.data.authUrl;
                    }
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }


                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchFtpDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/ftp/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_FTP_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    saveFtpSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/subacc_cannotchange_ftpserversettings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    addFtpToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_ftp_settings_subzones', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteFtpSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_ftp/' + authData.ftpIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        ftpData: response.data.ftpName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_FTP_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchAddEditFtpDetails({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/getFtpDetails', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    createFtpModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_edit_ftp', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        ftpData: response.data.ftpData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_FTP_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchWhatsappDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/customize_user_request_access/customize_whatsapp_settings/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_WHATSAPP_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    fetchWhatsappContent({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/captive_portal/customize_whatsapp_content/true")
            .then(response => {
                Nprogress.done()
                commit('SET_WHATSAPP_CONTENT', response.data)
            })
            .catch(error => console.log(error))
    },
    createWhatsappModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_default_operator_whatsapp', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        whatsappData: response.data.whatsappData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_WHATSAPP_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteWhatsappGatewaySubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/customize_user_request_access/delete_whatsapp_gateway/' + authData.whatsappIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        whatsappData: response.data.whatsappGatewayName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_WHATSAPP_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveWhatsappSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_sub_accounts_cannot_change_captiveportal_fields', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultWhatsappGatewaySubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/customize_user_request_access/make_default_whatsapp_gateway/' + authData.whatsappIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addWhatsappToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/add_all_whatsapp_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveWhatsappContent({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_whatsapp_contents/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        allData: postData,
                        // whatsappContentData: response.data.whatsappContentData,
                        // accountId: response.data.accountId
                    }
                    commit('UPDATE_WHATSAPP_CONTENT', dataList);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addCustomWhatsappTemplate({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_custom_whatsapp_contents', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        whatsappContentData: response.data,
                        accountId: response.data.accountId
                    }
                    commit('UPDATE_CUSTOM_WHATSAPP_CONTENT_LIST', dataList);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    exportWhatsappCsv({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/exportWhatsAppCsv', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteCustomWhatsappTemplate({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/delete_custom_whatsapp_template', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchPayGateDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/payment_gateway_settings/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_PAYMENT_GATEWAY_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createPayGateModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_default_payment_gateway_operator', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        payGateData: response.data.payGateData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_PAYMENT_GATEWAY_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultPayGateSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/make_default_gateway/' + authData.payGateIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addPayGateToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_all_payment_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    savePayGateSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_sub_accounts_cannot_change_paymentgateway_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deletePayGateSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_payment_gateway/' + authData.payGateIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        payGateData: response.data.payGatewayName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_PAYMENT_GATEWAY_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchEmailDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/customize_user_request_access/customize_email_settings/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_EMAIL_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    // fetchOutEmailContent({
    //     commit
    // }, authData) {
    //     Nprogress.start()
    //     axios.get("/customize_user_request_access/customize_email_content/true")
    //         .then(response => {
    //             Nprogress.done()
    //             commit('SET_OUT_EMAIL_CONTENT', response.data)
    //         })
    //         .catch(error => console.log(error))
    // },
    addEmailToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/add_all_email_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    addInEmailToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/add_inbound_email_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveOutEmailSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_sub_accounts_cannot_change_captiveportal_fields', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    saveInEmailSubAccSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_sub_accounts_cannot_change_captiveportal_fields', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteOutEmailSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/customize_user_request_access/delete_email_gateway/' + authData.outEmailIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        outEmailData: response.data.outEmailName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_OUTBOUND_EMAIL_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteInEmailSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/customize_user_request_access/delete_inbound_email_gateway/' + authData.inEmailIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        inEmailData: response.data.inEmailName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_INBOUND_EMAIL_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultOutEmailSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/customize_user_request_access/make_default_email_gateway/' + authData.outEmailIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultInEmailSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/customize_user_request_access/make_default_inbound_email_gateway/' + authData.inEmailIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    createInEmailModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_inbound_email_operator', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        inEmailData: response.data.inEmailData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_INBOUND_EMAIL_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    createOutEmailModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_default_email_operator', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        outEmailData: response.data.outEmailData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_OUTBOUND_EMAIL_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveEmailContent({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_email_contents/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        allData: postData,
                        accountId: postData.accountId,
                        custom: postData.custom
                    }
                    commit('UPDATE_EMAIL_CONTENT', dataList)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    exportEmailCsv({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/exportemailCsv', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addCustomEmailTemplate({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/save_custom_email_contents', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchPmsDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/pms/true")
            .then(response => {
                Nprogress.done()
                commit('SET_PMS_DETAILS', response.data)
            })
            .catch(error => console.log(error))
    },
    createPmsModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/pms/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }


                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    testPmsModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/pms_test/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }


                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchSocialNetworkDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/index/true")
            .then(response => {
                Nprogress.done()
                commit('SET_SOCIAL_NETWORKS_DETAILS', response.data)
            })
            .catch(error => console.log(error))
    },

    createSocialNetworkModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/social_networks/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchIvrDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/external_integration/customize_ivr")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push(response.data.message);
                } else {
                    commit('SET_IVR_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createIvrModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_ivr', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        ivrData: response.data.ivrData,
                        accountId: response.data.accountId
                    }
                    commit('ADD_IVR_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addIvrToAllSubZones({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/add_all_ivr_sub_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
    deleteIvrSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/delete_ivr/' + authData.ivrIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        ivrData: response.data.ivrGatewayName,
                        accountId: response.data.accountId
                    }
                    commit('DELETE_IVR_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    makeDefaultIvrSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/external_integration/make_default_ivr/' + authData.ivrIndex)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveSubAccIvrSettings({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/external_integration/save_sub_accounts_cannot_change_ivr_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },
}
const getters = {
    userStoreGetters: state => {
        return state.userStoreList;
    },
    xpressConnectGetters: state => {
        return state.xpressConnectList;
    },
    getSmsDetailsGetters: state => {
        return state.smsList;
    },
    smsContentGetters: state => {
        return state.smsContentList;
    },
    getOttDetailsGetters: state => {
        return state.ottList;
    },
    getEnachDetailsGetters: state => {
        return state.enachList;
    },
    getAadhaarkycDetailsGetters: state => {
        return state.aadhaarkycList;
    },
    getIpPhoneDetailsGetters: state => {
        return state.ipPhoneList;
    },
    ipPhoneContentGetters: state => {
        return state.ipPhoneContentList;
    },
    getIptvDetailsGetters: state => {
        return state.iptvList;
    },
    iptvContentGetters: state => {
        return state.iptvContentList;
    },
    getQuickBookDetailsGetters: state => {
        return state.quickBookList;
    },
    getWebHooksDetailsGetters: state => {
        return state.webHooksList;
    },
    getOneSignalDetailsGetters: state => {
        return state.oneSignalList;
    },
    getAmazonS3DetailsGetters: state => {
        return state.amazonS3List;
    },
    getGoogleDriveDetailsGetters: state => {
        return state.googleDriveList;
    },
    getFtpDetailsGetters: state => {
        return state.ftpList;
    },
    getWhatsappDetailsGetters: state => {
        return state.whatsappList;
    },
    whatsappContentGetters: state => {
        return state.whatsappContentList;
    },
    getPayGateDetailsGetters: state => {
        return state.payGateList;
    },
    getEmailDetailsGetters: state => {
        return state.emailList;
    },
    // outEmailContentGetters: state => {
    //     return state.outEmailContentList;
    // },getPmsDetailsGetters
    getPmsDetailsGetters: state => {
        return state.pmsList;
    },
    getSocialNetworksDetailsGetters: state => {
        return state.socialNetworkList;
    },
    emailContentGetters: state => {
        return state.emailContentData;
    },
    getIvrDetailsGetters: state => {
        return state.ivrList;
    },

}
export default {
    state,
    mutations,
    actions,
    getters
}
